
import { Toaster } from "sonner";

export function MazeToaster() {
  return (
    <Toaster
      position="bottom-center"
      expand={false}
      theme="dark"
      closeButton
    />
  );
}
